import React, {useState} from 'react';
import {MediaFile} from "types/MediaFile";
import MediaModal from "components/MediaModal";

type Props = {
    media: Array<MediaFile>
}

function Gallery(props: Props) {
    const {media} = props

    const [showingFile, setShowingFile] = useState<MediaFile | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);

    function handleClick(file: MediaFile) {
      setShowingFile(file);
      setShowModal(true);
    }

    return (
        <div>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:grid-cols-6 xl:gap-x-8">
                {media.map((file) => (
                    <li key={file.id} className="relative">
                        <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-brand overflow-hidden">
                            <img src={file.preview_url} alt={file.name} className="object-cover pointer-events-none group-hover:opacity-75" />
                            <button type="button" className="absolute inset-0 focus:outline-none" onClick={() => handleClick(file)}>
                                <span className="sr-only">View details for {file.name}</span>
                            </button>
                        </div>
                        <p className="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">{file.name}</p>
                        <p className="block text-sm text-gray-500 pointer-events-none">{file.type}</p>
                    </li>
                ))}
            </ul>

            <MediaModal file={showingFile} show={showModal} onClose={() => setShowModal(false)} />
        </div>
    );
}

export default Gallery;